__webpack_require__.p = "https://yapa.art.pl/zgloszenia/";